import { Grid, Typography } from '@mui/material';
import React, { useContext, useState } from 'react'
import styles from '../../../assets/styles/componentStyles/chats/botmessage.module.scss';
import templateMessageStyles from '../../../assets/styles/componentStyles/templatemessages.module.scss'
import { formatDateAccordingToTimezoneUsingMoment, getParseData, isAdmin, isJsonString, replacingTemplateMarkdownText } from '../../../utils/constants';
import { renderBotMsg, getMessageStatusIcons, renderUserMsg, renderThreadMsg } from '../renderUtils';
import { chatbot_action_execution_data, chatbotDetails, chatbotThemeModel, currentActiveThreadChatbotThreadData, getSpecificChatbotThreadData, quoteReplyData, reactionData, thread_template_data } from '../../../models/axiosModel';
import ChatLogsTemplatePreview from './components/chatbotActionLogView/chatLogsTemplatePreview';
import CopyToClipboard from 'react-copy-to-clipboard';
import IconsColor from '../../../components/utility/iconsColor';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import MessageFormatComponents from './components/chatbotActionLogView/messageFormatComponents';
import ChatLogsCarouselTemplatePreview from './components/chatbotActionLogView/chatLogsCarouselTemplatePreview';
import globalStyles from "../../../assets/styles/global.module.scss";
import botIcon from "../../../assets/images/chatbot/chatbotProfileAvtar.png";
import humanAgentIcon from "../../../assets/images/chatWidgetComponents/avatar.png";
import chatModuleStyles from "../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss"
import CarouselTemplatePreviewInbox from './components/chatbotActionLogView/carouselTemplatePreviewInbox';
import GlobalTooltip from '../../../components/utility/tooltip/globalTooltip';
import { getBotMessageCopyText, getDynamicColorsBySource, getFullAgentName, getMessageType, getReleventWhatsappStatus, stripMarkdown } from '../utils';
import { useRuleBasedInboxStore } from '../../../store/ruleBasedInboxStore';
import { ACTION_TYPE_NAME } from '../../../components/dashboard/flowBuilder/flowBuilderConstants';
import { THREAD_CHANNEL_NAMES } from '../constants';

interface BotMessageActionExecutionData extends chatbot_action_execution_data {
    thread_template_data?: thread_template_data | null;
    chatbot_thread_value?: string;
    reaction_data?: reactionData[];
    ai_response_time?: string;
    total_response_time?: string;
    chatbot_data?: chatbotDetails & { chatbot_logo_url?: string | null };
}

interface BotMessageThread extends Omit<currentActiveThreadChatbotThreadData, 'action_execution_data'> {
    action_execution_data: BotMessageActionExecutionData;
    quote_reply_data?: quoteReplyData;
    flag_loader?: boolean;
    user_first_name?: string | null;
    user_last_name?: string | null;
}

interface BotMessageProps {
    thread: BotMessageThread;
    aiMessageExecutionActionType: boolean;
    ind: number;
    targetRef: React.RefObject<HTMLElement | null>;
    getQuotedThread: (thread: currentActiveThreadChatbotThreadData) => currentActiveThreadChatbotThreadData | undefined;
}

const BotMessage = (props: BotMessageProps) => {

    const { thread, aiMessageExecutionActionType, ind, targetRef, getQuotedThread } = props;
    
    const { userDetail } = useContext(UserContext) as UserContextPayload
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload
    
    const currentActiveChatbotThread = useRuleBasedInboxStore((state) => state.currentActiveChatbotThread);
    
    const [copyText, setCopyText] = useState<string>("Copy");
    
    const actionExecutionData = thread?.action_execution_data;
    const threadTemplateData = actionExecutionData?.thread_template_data;
    const threadTemplateActionData = threadTemplateData?.action_execution_data;
    const reactionList = actionExecutionData?.reaction_data;
    // null when there is nothing to copy (e.g. action cards), which hides the copy icon
    const copyMessageText = getBotMessageCopyText(thread);

    return (
        <Grid item className={styles.botMessageBlockItem}
        >
            <Grid container className={styles.botMessageBlockContainer}>

                <Grid item
                    className={styles.botMessageBlock}
                    sx={{
                        display: getParseData(thread?.chatbot_thread_value)?.error_message && getParseData(thread?.chatbot_thread_value)?.error_message.toLowerCase() != "no error found" ? "block" : getParseData(thread?.chatbot_thread_value)?.flag_hide_main_message ? "none" : "block",
                        backgroundColor: getDynamicColorsBySource(currentActiveChatbotThread?.chatbot_user_route_source ?? "", currentActiveChatbotThread, chatBotDetails).system_msg_bg_color,
                    }}
                >
                    <Typography
                        component="div"
                        className={styles.botMessageTypography}
                        sx={{
                            color: getDynamicColorsBySource(currentActiveChatbotThread?.chatbot_user_route_source ?? "").system_msg_color,
                        }}
                        dir="auto"
                    >
                        <div className={styles.botMessageContentWrapper}>
                            <div className={styles.botMessageBody}>
                            {
                                (!aiMessageExecutionActionType) ?
                                    renderBotMsg(thread.chatbot_thread_action_type, thread.chatbot_action_execution_data, ind, targetRef, thread)
                                    :
                                    <>
                                        {threadTemplateData != null ?
                                                <>
                                                    {"wa_variation_data" in threadTemplateData.action_execution_data ?
                                                        <pre
                                                            className={templateMessageStyles.preTextStyle}
                                                            dangerouslySetInnerHTML={{ __html: replacingTemplateMarkdownText(("wa_carousel_header" in threadTemplateData.action_execution_data ? threadTemplateData.action_execution_data.wa_carousel_header : '') ?? '') }}
                                                        />
                                                        :
                                                        <>
                                                            {"wa_template_other_template_detail" in threadTemplateData.action_execution_data ?
                                                                <span>{threadTemplateData.action_execution_data.wa_template_other_template_detail || ""}</span>
                                                                :
                                                                <ChatLogsTemplatePreview
                                                                    actionData={threadTemplateData.action_execution_data}
                                                                    key={ind}
                                                                    ref={targetRef}
                                                                />
                                                            }
                                                        </>}
                                                </>
                                                :
                                                <>
                                                    {
                                                        isJsonString(actionExecutionData?.chatbot_thread_value) && !("flag_loader" in thread) && typeof getParseData(actionExecutionData?.chatbot_thread_value) == "object" && (getParseData(actionExecutionData?.chatbot_thread_value)?.error_message && getParseData(actionExecutionData?.chatbot_thread_value)?.error_message.toLowerCase() != "no error found") ?
                                                            getParseData(actionExecutionData?.chatbot_thread_value)?.error_message
                                                            :
                                                            <>
                                                                {isJsonString(actionExecutionData?.chatbot_thread_value) && !("flag_loader" in thread) && typeof getParseData(actionExecutionData?.chatbot_thread_value) == "object" && Math.trunc(getParseData(actionExecutionData?.chatbot_thread_value).message_format_id) == 8 ?
                                                                    <span>{renderThreadMsg(actionExecutionData, getMessageType(actionExecutionData), false, targetRef)}</span>
                                                                    :
                                                                    renderThreadMsg(actionExecutionData, getMessageType(actionExecutionData), false, targetRef)}
                                                            </>
                                                    }
                                                </>
                                        }
                                    </>
                            }
                            </div>

                            {(("quote_reply_data" in thread && thread?.quote_reply_data && thread?.quote_reply_data?.chatbot_thread_id != null) || thread?.parent_thread_execution_log_id) && (
                                <div 
                                    className={styles.botMessageQuoteReplyData}
                                >
                                    {(!aiMessageExecutionActionType) ?
                                        <>
                                            <div
                                                className={`${globalStyles.primaryColor} ${globalStyles.primaryFontWeight}`}
                                            >
                                                {getQuotedThread(thread)?.flag_user_message ? "You" : currentActiveChatbotThread?.chatbot_name}
                                            </div> 
                                            {/* {renderBotMsg(getQuotedThread(thread)?.chatbot_thread_action_type, getQuotedThread(thread).chatbot_action_execution_data, ind, targetRef, thread)} */}
                                            {renderUserMsg(getQuotedThread(thread), targetRef)}
                                            {getQuotedThread(thread)?.action_type_name?.toLowerCase() == ACTION_TYPE_NAME['CAROUSEL_TEMPLATE']?.toLowerCase() && 
                                                <CarouselTemplatePreviewInbox
                                                    actionData={getQuotedThread(thread)?.chatbot_action_execution_data}  
                                                    justifyContent="start"
                                                />
                                            }
                                        </>
                                        :  
                                        <>
                                            <div
                                                className={`${globalStyles.primaryColor} ${globalStyles.primaryFontWeight}`}
                                            >
                                                {/* {currentActiveChatbotThread?.chatbot_thread_data?.find((initialThread: getSpecificChatbotThreadData | currentActiveThreadChatbotThreadData) => initialThread?.chatbot_thread_id == thread?.action_execution_data?.quote_reply_data?.chatbot_thread_id)?.flag_user_message ? "You" : currentActiveChatbotThread.chatbot_name} */}
                                                {currentActiveChatbotThread?.chatbot_thread_data?.find((initialThread: getSpecificChatbotThreadData | currentActiveThreadChatbotThreadData) => initialThread?.chatbot_thread_id == thread?.parent_thread_execution_log_id)?.flag_user_message ? "You" : currentActiveChatbotThread?.chatbot_name ?? ""}
                                            </div>
            
                                            {/* {renderThreadMsg(currentActiveChatbotThread?.chatbot_thread_data?.find((initialThread: getSpecificChatbotThreadData | currentActiveThreadChatbotThreadData) => initialThread?.chatbot_thread_id == thread?.action_execution_data?.quote_reply_data?.chatbot_thread_id), "messageReply", true)} */}
                                            {renderThreadMsg(currentActiveChatbotThread?.chatbot_thread_data?.find((initialThread: getSpecificChatbotThreadData | currentActiveThreadChatbotThreadData) => initialThread?.chatbot_thread_id == thread?.parent_thread_execution_log_id)?.action_execution_data, "messageReply", true)}
                                        </>
                                    }
                                </div>
                            )}
                        </div>
                    </Typography>

                    { reactionList && "reaction_data" in reactionList && reactionList[0].reaction_emoji_character !== "" && reactionList.map((reaction: reactionData, reactionInd: number) => {
                        return <React.Fragment key={reactionInd}>
                            <p className={chatModuleStyles.reactionUserStyle}>{reaction.reaction_emoji_character}</p>
                        </React.Fragment>
                    }
                    )}

                    {copyMessageText &&
                    <CopyToClipboard text={stripMarkdown(copyMessageText)}>
                        <GlobalTooltip
                            title={copyText}
                            arrow
                            onMouseLeave={() => setCopyText("Copy!")}
                            onClick={() => {
                                setCopyText("Copied!");
                            }}
                        >
                            <Grid item
                                className={styles.botCopyIcon}>
                                <IconsColor
                                    iconName={"Copy"}
                                    fillColor={"black"}
                                    width={"16"}
                                    height={"16"}
                                />&nbsp;
                            </Grid>
                        </GlobalTooltip>
                    </CopyToClipboard>
                    }
                    
                    <Grid container gap={"3px"} justifyContent={"end"} alignItems={"center"} sx={{ margin: '4px 0 1px 0' }}>
                        <span className={chatModuleStyles.whatsAppStatusSpan} style={{ color: getDynamicColorsBySource(currentActiveChatbotThread?.chatbot_user_route_source ?? "").system_msg_color }}> {formatDateAccordingToTimezoneUsingMoment(thread.timestamp, userDetail.timezone_hour, "all")}</span>
                        {getMessageStatusIcons(getReleventWhatsappStatus(thread), thread, aiMessageExecutionActionType)}
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction={"column"} gap={"2px"} alignItems={"end"}>
                        {(isAdmin(userDetail) && aiMessageExecutionActionType) &&
                            <Grid item className={styles.responseTimeIconGrid}>
                                <GlobalTooltip
                                    title={
                                        <Grid container direction={"column"}>
                                            <Grid item>
                                                <Grid container justifyContent={"space-between"} gap={1}>
                                                    <Grid item><span>{`AI Response Time: `}</span></Grid>
                                                    <Grid item><span>{(actionExecutionData && "ai_response_time" in actionExecutionData) ? actionExecutionData.ai_response_time : ""}</span></Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item>
                                                <Grid container justifyContent={"space-between"} gap={1}>
                                                    <Grid item><span>{`Total Response Time: `}</span></Grid>
                                                    <Grid item><span>{(actionExecutionData && "total_response_time" in actionExecutionData) ? actionExecutionData.total_response_time : ""}</span></Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    } 
                                    placement='top-end'
                                    arrow 
                                >
                                    <ScheduleSendIcon className={styles.responseTimeIcon} sx={{ color: getDynamicColorsBySource(currentActiveChatbotThread?.chatbot_user_route_source ?? "").schedule_send_icon_color }} />
                                </GlobalTooltip>
                            </Grid>
                        }
                        <Grid item>
                            {(thread.user_assignment_id != null && thread.thread_chatbot_id == null) ?
                                <GlobalTooltip
                                    title={getFullAgentName(thread?.user_first_name ?? "", thread?.user_last_name ?? "")}
                                    placement='top-end'
                                    arrow
                                >
                                    <Grid item>
                                        <img
                                            src={humanAgentIcon}
                                            alt="humanAgent Icon"
                                            className={styles.botMessageIcon}
                                        />
                                    </Grid>
                                </GlobalTooltip>
                                :
                                <GlobalTooltip
                                    title={(aiMessageExecutionActionType ? thread?.action_execution_data?.chatbot_data?.chatbot_name : thread?.chatbot_data?.chatbot_name) ?? "Chatbot"}
                                    placement='top-end'
                                    arrow
                                >
                                    <img
                                        // src={(currentActiveChatbotThread && currentActiveChatbotThread?.chatbot_data && "chatbot_logo_url" in currentActiveChatbotThread?.chatbot_data && currentActiveChatbotThread?.chatbot_data?.chatbot_logo_url) ? currentActiveChatbotThread?.chatbot_data?.chatbot_logo_url : botIcon}
                                        src={thread?.action_execution_data?.chatbot_data?.chatbot_logo_url ? thread?.action_execution_data?.chatbot_data?.chatbot_logo_url : botIcon}
                                        alt="chatbot Icona"
                                        className={styles.botMessageIcon}
                                    />
                                </GlobalTooltip>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {currentActiveChatbotThread && currentActiveChatbotThread.chatbot_user_route_source.toLowerCase() !== THREAD_CHANNEL_NAMES['WHATSAPP']?.toLowerCase() &&
                <Grid container className={styles.messageFormatComponents}>
                    <MessageFormatComponents
                        thread={thread?.action_execution_data}
                        currentActiveChatbotThread={currentActiveChatbotThread}
                    />
                </Grid>
            }

            {/* carousel in AI chatbots */}
            {aiMessageExecutionActionType && threadTemplateData != null && threadTemplateActionData && "wa_variation_data" in threadTemplateActionData &&
                <Grid container className={styles.messageFormatComponents}>
                    <ChatLogsCarouselTemplatePreview
                        actionData={threadTemplateActionData}
                        chatbotTheme={(currentActiveChatbotThread && "chatbot_theme" in currentActiveChatbotThread) ? currentActiveChatbotThread.chatbot_theme as chatbotThemeModel : {}}
                    />
                </Grid>
            }
            {/* multiple image/single image with template for mundos chiapas */}
            {aiMessageExecutionActionType && threadTemplateData != null && threadTemplateActionData && "wa_template_other_template_detail" in threadTemplateActionData &&
                <Grid container className={styles.messageFormatComponentsForMultipleImages}>

                    {"wa_template_other_image_url" in threadTemplateActionData &&
                        threadTemplateActionData.wa_template_other_image_url?.map((img: string, imageInd: number) => {
                            return (
                                <Grid item key={imageInd} className={globalStyles.marginBottom5}>
                                    <img src={img} alt="other_images" className={styles.multipleImagesMessageFormat} />
                                </Grid>
                            );
                        })
                    }
                    <ChatLogsTemplatePreview
                        actionData={threadTemplateActionData}
                        key={ind}
                        ref={targetRef}
                    />
                </Grid>
            }
            {thread?.action_type_name?.toLowerCase() == ACTION_TYPE_NAME['CAROUSEL_TEMPLATE']?.toLowerCase() && 
                <CarouselTemplatePreviewInbox actionData={thread.chatbot_action_execution_data} justifyContent="end" /> 
            }
        </Grid>
    )
}

export default BotMessage